module.exports = __webpack_public_path__ + "img/unchecked.2e7afd35.svg";